import { RequestUnsuccessComponent } from '../self-request/request-unsuccess/request-unsuccess.component';
import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { BillingHeaderComponent } from '../billing-header/billing-header.component';
import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router , RouterModule } from '@angular/router';
import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import { FormControl, FormGroup, Validators , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { BillingDetailsService } from '@services/my-insurance/billing-details.service';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { RefundsService } from '@services/refunds.service';
import { BillingRequestService } from '@services/billing-request.service';
import { RefundSelectedReasonComponent } from '../self-request/refund-selected-reason/refund-selected-reason.component';
import { Constants } from '@models/constants';
import { Topic } from '@models/topic';
import { UserDataService } from '@services/data-services/user-data.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbFormsModule, MapfreLoadingComponent, MapfreCardComponent, BillingHeaderComponent, MapfreButtonComponent, RefundSelectedReasonComponent, MapfreModalComponent, RequestUnsuccessComponent],
  selector: 'app-billing-refund-request',
  templateUrl: './billing-refund-request.component.html',
  styleUrls: ['./billing-refund-request.component.scss']
})
export class BillingRefundRequestComponent implements OnInit {
  @ViewChild('refundReason')
  refundReason: RefundSelectedReasonComponent;

  @ViewChild('questionAbtMyRefund') questionAbtMyRefund: ElementRef;

  failureSubmitModal: ModalOptions;
  loader: boolean;
  submitLoading: boolean;
  policy: any;
  policyType: string;
  documents: File[];
  loading: boolean;
  requestTypeList: Array<any>;
  policyTypeImg: string;
  billingDiscountForm: FormGroup;
  isAcmic: boolean;
  isSubmitActive: boolean;
  discountName = '';
  showGoodStudent: boolean;
  showPanMassChallenge: boolean;
  showStudentAway: boolean;
  showFailureModal: boolean;
  hideModal = false;
  topicOptions: Topic[];
  reasonOptions: Topic[];
  reissueRefundOptions: Topic[];
  questionAboutRefundOptions: Topic[];
  sniName: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private policyDataService: PolicyDataService,
    private acmicService: AcmicService,
    private storageObservable: StorageServiceObservablesService,
    private billingDetailsService: BillingDetailsService,
    private refundsService: RefundsService,
    private billingRequestService: BillingRequestService,
    private userDataService: UserDataService
  ) {
    this.showGoodStudent = false;
    this.showPanMassChallenge = false;
    this.showStudentAway = false;
    this.isSubmitActive = false;
    this.showFailureModal = false;
    this.submitLoading = false;
    this.reasonOptions = [];
    this.reissueRefundOptions = [];
    this.questionAboutRefundOptions = [];
  }

  loadInitialOptions() {
    this.topicOptions = this.refundsService.getTopicOptions();
    this.reissueRefundOptions = this.refundsService.getReissueRefundOptions();
    this.questionAboutRefundOptions = this.refundsService.getQuestionAboutRefundOptions();
  }

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.loadInitialOptions();
    this.loading = true;
    this.documents = [];
    this.activatedRoute.params.subscribe((params: Params) => {
      const policyId = params['policyid'];
      this.policyDataService.$policyDetails.subscribe((policyResponse) => {
        if (policyResponse) {
          this.policy = policyResponse
            .find(policyDetails => policyDetails.policynumber.policyNumber === policyId);
          this.setPolicyInfo(this.policy)
          this.setSNI(this.policy);
          this.loading = false;
        }
      });
    });
    this.clearForm()
  }

  setPolicyInfo(policy: any) {
    this.policyType = this.policy?.policyType;
    this.policyTypeImg = this.billingRequestService.setPolicyTypeImage(this.policyType);
    this.requestTypeList = this.billingRequestService.getRequestTypeList(policy);
  }
  setSNI(policy: any){
    if(policy && policy?.insured?.length){
      const sniDetails = policy.insured.find(insurer => !insurer.isPrimaryInsured);
      if(sniDetails) {
        this.sniName = sniDetails.insuredFullName;
      }
    }
  }

  clearForm() {
    this.billingDiscountForm = new FormGroup({
      topic: new FormControl(null, Validators.required),
      reason: new FormControl(null, Validators.required),
    });
  }

  setActiveSubmitButton(flag?){
      this.isSubmitActive = flag;
  }

  onBack(){
    if(this.billingDiscountForm.controls.reason.value !== null){
      this.billingDiscountForm.controls.reason.setValue(null);
    }else{
      this.router.navigate(['/my-insurance', this.policy.policynumber.policyNumber, 'billing-request']);
    }
  }

  sendQuestion(){
    let refundReasonData: any;
    let requestPayload;
    if(this.billingDiscountForm?.controls?.topic?.value ==='Reissue my refund') {
      refundReasonData = this.refundReason.getDataToSubmit();
      requestPayload = this.buildRequestPayloadObj(refundReasonData);
      requestPayload.addProperties = { ...requestPayload.addProperties, ...refundReasonData.addProperties};
    } else {
      const questionAddlData = {
        addInfo: this.questionAbtMyRefund.nativeElement.value
      };
      requestPayload = this.buildRequestPayloadObj(questionAddlData);
    }
    this.submitRequest(requestPayload);
  }
  
  getAccountHolderName() {
    // Primary source: policy's accountHolder (already loaded on this page, used in the template)
    const policyAccountHolder = this.policy?.accountHolder;
    if (policyAccountHolder?.firstName || policyAccountHolder?.insuredFullName) {
      const [firstName, ...rest] = (policyAccountHolder.insuredFullName || '').split(' ');
      return {
        firstName: policyAccountHolder.firstName ?? firstName,
        lastName: policyAccountHolder.lastName ?? rest.join(' ')
      };
    }
    // Fallback: localStorage (set only during login flow, may be stale/missing)
    const storedAccountHolder = JSON.parse(localStorage.getItem('accountHolder'));
    if (storedAccountHolder?.firstName) {
      return { firstName: storedAccountHolder.firstName, lastName: storedAccountHolder.lastName };
    }
    // Last resort: in-memory reactive data set via UserDataService
    let reactiveName = { firstName: undefined, lastName: undefined };
    this.userDataService.$customerData.subscribe((customer) => {
      if (customer?.firstName) {
        reactiveName = { firstName: customer.firstName, lastName: customer.lastName };
      }
    });
    return reactiveName;
  }

  buildRequestPayloadObj(refundReasonData){
    const { firstName, lastName } = this.getAccountHolderName();
    const obj = {
      policyNumber: this.policy.policynumber.policyNumber,
      policyType: this.policy?.displayType?.label?.toUpperCase() ?? this.policy?.policyType,
      firstName,
      lastName,
      inquiryDate: new Date().toLocaleDateString(),
      inquiryTime: new Date().toLocaleTimeString(),
      inquiryTopic: Constants.REFUNDS_TOPIC,
      inquiry: refundReasonData && refundReasonData.addInfo ? refundReasonData.addInfo : '',
      email: this.storageObservable.getUserFromStorage(),
      addProperties: {
        inquirySubTopic: this.billingDiscountForm.controls.topic.value,
        details: this.billingDiscountForm.controls.reason.value
      },
      isSelfCustomerRequest: true
    };
    return obj;
  }

  submitRequest(payload: any){
    this.submitLoading = true;
    this.billingDetailsService.sendBillingQuestion(
        payload,
        this.storageObservable.getUserFromStorage()
      )
      .subscribe(
        () => {
          this.router.navigate(['/my-insurance', this.policy.policynumber.policyNumber, 'self-request', 'success'], {
            queryParams: { request: 'refund' },
            state: { reason: this.billingDiscountForm.controls.reason.value }
          });  
          this.submitLoading = false;
        },
        () => {
          this.initFailureSubmitModal();
          this.showFailureModal = true;
          this.submitLoading = false;
        }
      );
  }

  initFailureSubmitModal(): void {
    this.failureSubmitModal = new ModalOptions({
      additionalClasses:
        'modal-lg modal-dialog center-on-page confirm-modal email-update edit-contact-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'failureSubmitModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      size: 'modal-lg',
      modalName: 'failure-Submit-Modal',
    });
    this.loading = false;
  }

  resetHideModal(){
    this.hideModal = !this.hideModal;
  }

  onTopicChange() {
    this.billingDiscountForm.controls.reason.setValue(null)
    this.isSubmitActive = false;
    if(this.billingDiscountForm.controls.topic.value === this.topicOptions[1].name) {
      this.reasonOptions = this.reissueRefundOptions;
    }else{
      this.reasonOptions = this.questionAboutRefundOptions;
    }
  }
  onReasonChange() {
    this.isSubmitActive = false;
    if(this.billingDiscountForm.controls.topic.value === 'Question about my refund' && this.billingDiscountForm.controls.reason.value) {
      this.isSubmitActive = true;
      if(this.questionAbtMyRefund && this.questionAbtMyRefund.nativeElement.value){
        this.questionAbtMyRefund.nativeElement.value = '';
      }
    }
  }

  tryAgain(event: boolean) {
    this.showFailureModal = false;
    if(!event){
      this.router.navigate(['/billing-new', this.policy?.policynumber?.policyNumber, 'details']);
    }
  }
}
